import { BRIDGE } from 'core/constants/bridge'
import { getUA } from 'core/singleton'
import { requestBridge } from 'core/util/default'
import { PropsWithChildren, useEffect, useRef } from 'react'

type Props = {
  className?: string
  trigger?: string
  elementId?: string
}

const SectionLayout = ({ children, className, trigger, elementId }: PropsWithChildren<Props>) => {
  const ref = useRef<HTMLDivElement>(null)
  const { isSDK } = getUA()

  /**
   * section 내에서 어떤 동작을 할 때마다 변화되는 값
   */
  useEffect(() => {
    const layoutEl = ref.current
    if (!isSDK || !layoutEl || !trigger || !elementId) return

    const bridgeTimer = setTimeout(() => {
      requestBridge(BRIDGE.DOM_RECT, {
        domRect: layoutEl.getBoundingClientRect(),
        elementId,
      })
    }, 0.5 * 100)

    return () => {
      clearTimeout(bridgeTimer)
    }
  }, [trigger, elementId, isSDK])

  return (
    <div id={elementId} ref={ref} className={className}>
      {children}
    </div>
  )
}

export default SectionLayout
